import { AppInfo } from "shared-ts-app-info";
import { ResponsiveMyChimneyLogo } from "firefly-my-chimney-ts-shared";

export const appKey = "ff-mc";
export const appName = "My Chimney";
export const appRelease = "2025.3.2";

export const appInfo: AppInfo = {
  key: appKey,
  name: appName,
  release: appRelease,
  icon: {
    large: <ResponsiveMyChimneyLogo />,
  },
};
